export async function deleteContentApi({ id, collection, vertical_id, token }) {
  const res = await fetch(
    `${process.env.REACT_APP_FLASK_WEBSERVER}delete_content?id=${id}&collection=${collection}&vertical_id=${vertical_id}`,
    {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }
  );

  if (!res.ok) {
    throw new Error('Failed to delete content');
  }

  return res.json();
}

export async function deleteContentsApi({ collection, vertical_id, ids, token }) {
  const res = await fetch(
    `${process.env.REACT_APP_FLASK_WEBSERVER}delete_contents?ids=${ids}&collection=${collection}&vertical_id=${vertical_id}`,
    {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }
  );

  if (!res.ok) {
    throw new Error('Failed to delete content');
  }

  return res.json();
}

export async function deleteBookmark({ id, vertical_id, token }) {
  const res = await fetch(
    `${process.env.REACT_APP_FLASK_WEBSERVER}delete_bookmark?item_id=${id}&vertical_id=${vertical_id}`,
    {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  if (!res.ok) {
    throw new Error('Failed to delete content');
  }

  return res.json();
}
